(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
class AnnouncementBar extends HTMLElement {
  #slides = []
  #index = 0
  #timer

  constructor() {
    super()
    this.#slides = Array.from(this.querySelectorAll('[data-announcement-slide]'))
    if (this.#slides.length <= 1) return

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-announcement-prev]')) this.#show(this.#index - 1)
      if (event.target.closest('[data-announcement-next]')) this.#show(this.#index + 1)
    })

    if (this.dataset.autoRotate === 'true') {
      const interval = (Number(this.dataset.interval) || 5) * 1000
      this.#timer = window.setInterval(() => this.#show(this.#index + 1), interval)
    }
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer)
  }

  #show(index) {
    this.#index = (index + this.#slides.length) % this.#slides.length
    this.#slides.forEach((slide, i) => {
      const active = i === this.#index
      slide.hidden = !active
      slide.classList.toggle('is-active', active)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
class ReelVideos {
  constructor() {
    for (const button of document.querySelectorAll('[data-reel-toggle]')) {
      const video = button.previousElementSibling
      if (!video || video.tagName !== 'VIDEO') continue
      button.addEventListener('click', () => this.#toggle(button, video))
    }
  }

  #toggle(button, video) {
    const willPlay = video.paused
    if (willPlay) {
      video.play()
    } else {
      video.pause()
    }
    button.classList.toggle('is-paused', !willPlay)
    button.setAttribute('aria-label', willPlay ? 'Pause video' : 'Play video')
  }
}

document.addEventListener('DOMContentLoaded', () => new ReelVideos())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
class CartDrawer {
  #root
  #backdrop
  #closeButton
  #content

  #lastFocused

  constructor() {
    this.#root = document.getElementById('CartDrawer')
    this.#backdrop = document.getElementById('CartDrawerBackdrop')
    this.#closeButton = document.getElementById('CartDrawerClose')
    this.#content = document.getElementById('CartDrawerContent')
    if (!this.#root || !this.#backdrop || !this.#content) return

    document.addEventListener('cart:open', () => this.open())
    document.addEventListener('cart:updated', (event) => this.#onCartUpdated(event))
    this.#closeButton.addEventListener('click', () => this.close())
    this.#backdrop.addEventListener('click', () => this.close())
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  open() {
    this.#lastFocused = document.activeElement
    this.#root.hidden = false
    this.#root.inert = false
    this.#backdrop.hidden = false
    requestAnimationFrame(() => {
      this.#root.classList.add('is-open')
      this.#backdrop.classList.add('is-open')
    })
    this.#root.setAttribute('aria-hidden', 'false')
    this.#closeButton.focus()
    document.body.classList.add('cart-drawer-open')
  }

  close() {
    this.#root.classList.remove('is-open')
    this.#backdrop.classList.remove('is-open')
    this.#root.setAttribute('aria-hidden', 'true')
    this.#root.inert = true
    document.body.classList.remove('cart-drawer-open')
    window.setTimeout(() => {
      if (!this.#root.classList.contains('is-open')) {
        this.#root.hidden = true
        this.#backdrop.hidden = true
      }
    }, 300)
    this.#lastFocused?.focus()
  }

  #onCartUpdated(event) {
    const sections = event.detail?.sections
    if (!sections || !sections['cart-drawer']) return
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html')

    const newContent = doc.getElementById('CartDrawerContent')
    if (newContent) {
      this.#content.innerHTML = newContent.innerHTML
      this.#content.classList.remove('is-loading')
    }

    const newFooter = doc.getElementById('CartDrawerFooter')
    const currentFooter = this.#root.querySelector('#CartDrawerFooter')
    currentFooter?.remove()
    if (newFooter) this.#content.after(newFooter)

    if (event.detail.openDrawer !== false) this.open()
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#root.classList.contains('is-open')) {
      this.close()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new CartDrawer())

class CartRecommendations extends HTMLElement {
  #observer
  #request
  #track
  #slides
  #prevButton
  #nextButton

  connectedCallback() {
    this.#observer?.disconnect()
    this.#observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)
        this.#load()
      },
      { rootMargin: '0px 0px 400px 0px' }
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
    this.#request?.abort()
  }

  async #load() {
    const productId = this.dataset.productId
    if (!productId) return
    try {
      this.#request?.abort()
      this.#request = new AbortController()
      const response = await fetch(`${this.dataset.url}&product_id=${productId}`, {
        signal: this.#request.signal,
      })
      if (!response.ok) throw new Error(`Cart recommendations request failed: ${response.status}`)
      const text = await response.text()
      if (!this.isConnected) return
      const doc = new DOMParser().parseFromString(text, 'text/html')
      const newContent = doc.querySelector('cart-recs')
      if (newContent && newContent.innerHTML.trim().length) {
        this.innerHTML = newContent.innerHTML
        this.#initSlider()
      }
    } catch (error) {
      if (error.name === 'AbortError') return
      console.error('Cart recommendations error:', error)
    }
  }

  #initSlider() {
    this.#track = this.querySelector('[data-slider-track]')
    if (!this.#track) return
    this.#slides = Array.from(this.querySelectorAll('[data-slider-slide]'))
    this.#prevButton = this.querySelector('[data-slider-prev]')
    this.#nextButton = this.querySelector('[data-slider-next]')

    this.#track.addEventListener('scroll', () => this.#updateArrows())

    this.#prevButton?.addEventListener('click', () => this.#scrollByDirection(-1))
    this.#nextButton?.addEventListener('click', () => this.#scrollByDirection(1))

    const hasOverflow = this.#track.scrollWidth > this.#track.clientWidth + 2
    this.classList.toggle('has-arrows', hasOverflow)
    this.#updateArrows()
  }

  #updateArrows() {
    if (!this.#track || !this.#prevButton || !this.#nextButton) return
    this.#prevButton.disabled = this.#track.scrollLeft <= 2
    this.#nextButton.disabled = this.#track.scrollLeft + this.#track.clientWidth >= this.#track.scrollWidth - 2
  }

  #scrollByDirection(direction) {
    const slideWidth = this.#slides?.[0]?.clientWidth || 0
    const gap = parseInt(window.getComputedStyle(this.#track).gap) || 0
    this.#track.scrollBy({ left: (slideWidth + gap) * direction, behavior: 'smooth' })
  }

}

if (!customElements.get('cart-recs')) {
  customElements.define('cart-recs', CartRecommendations)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-slider"] && !Shopify.designMode) return;
  try {
    
  class FeaturesSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-slider-track]');
      this.prevBtn = this.querySelector('.features-slider__arrow--prev');
      this.nextBtn = this.querySelector('.features-slider__arrow--next');
      this.dots = Array.from(this.querySelectorAll('.features-slider__dot'));
      this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));

      this.isDragging = false;
      this.dragStartX = 0;
      this.dragScrollLeft = 0;

      this.init();
      window.addEventListener('resize', () => this.init());
      this.track.addEventListener('scroll', () => this.updateUI());

      // Touch already drag-scrolls natively (native overflow-x + scroll-snap);
      // this only adds click-and-drag support for mouse, matching the product gallery.
      this.track.addEventListener('pointerdown', (e) => this.onDragStart(e));
      this.track.addEventListener('pointermove', (e) => this.onDragMove(e));
      this.track.addEventListener('pointerup', (e) => this.onDragEnd(e));
      this.track.addEventListener('pointercancel', (e) => this.onDragEnd(e));

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByDirection(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByDirection(1));

      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          const index = parseInt(e.target.dataset.index);
          if (!isNaN(index) && this.slides[index]) {
            const scrollPos = this.slides[index].offsetLeft - this.track.offsetLeft;
            this.track.scrollTo({ left: scrollPos, behavior: 'smooth' });
          }
        });
      });
    }

    init() {
      if (!this.track) return;
      
      // Check if track has overflow
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
      
      if (hasOverflow) {
        this.classList.add('has-arrows', 'has-dots');
        this.updateUI();
      } else {
        this.classList.remove('has-arrows', 'has-dots');
      }
    }

    updateUI() {
      if (!this.classList.contains('has-arrows')) return;
      
      // Arrows state
      const isAtStart = this.track.scrollLeft <= 2;
      const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      
      if (this.prevBtn) this.prevBtn.disabled = isAtStart;
      if (this.nextBtn) this.nextBtn.disabled = isAtEnd;

      // Dots state based on closest slide to the left edge of track
      let activeIndex = 0;
      let minDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const slideLeft = slide.offsetLeft - this.track.offsetLeft;
        const distance = Math.abs(slideLeft - this.track.scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    scrollByDirection(direction) {
      const slideWidth = this.slides[0]?.clientWidth || 0;
      const gap = parseInt(window.getComputedStyle(this.track).gap) || 0;
      const scrollAmount = slideWidth + gap;

      this.track.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    }

    onDragStart(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragScrollLeft = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture(event.pointerId);
    }

    onDragMove(event) {
      if (!this.isDragging) return;
      event.preventDefault();
      this.track.scrollLeft = this.dragScrollLeft - (event.clientX - this.dragStartX);
    }

    onDragEnd(event) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      this.track.releasePointerCapture(event.pointerId);
    }
  }

  if (!customElements.get('features-slider')) {
    customElements.define('features-slider', FeaturesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fix-footer-mobile"] && !Shopify.designMode) return;
  try {
    
class MobileBottomNavReveal extends HTMLElement {
  #nav
  #footer
  #footerObserver
  #footerVisible = false
  #ticking = false

  connectedCallback() {
    this.#nav = this.querySelector('.mobile-bottom-nav')
    if (!this.#nav) return

    window.addEventListener('scroll', this.#requestUpdate, { passive: true })
    window.addEventListener('resize', this.#requestUpdate, { passive: true })

    // Same idea as the product page's sticky add-to-cart bar: get out of the
    // way once the footer scrolls into view, so the bar never sits on top of
    // it (or of its links).
    this.#footer = document.querySelector('.shopify-section-group-footer-group')
    if (this.#footer && 'IntersectionObserver' in window) {
      // Seeded synchronously so a load that's already at/near the footer
      // doesn't flash the bar in for a frame before the observer reports.
      this.#footerVisible = this.#footer.getBoundingClientRect().top < window.innerHeight
      this.#footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.#footerVisible = entry.isIntersecting
          this.#update()
        },
        { threshold: 0 }
      )
      this.#footerObserver.observe(this.#footer)
    }

    // Sync once now: after a reload the browser can restore a scrolled position
    // before any scroll event fires, and a page too short to scroll at all
    // would otherwise never reveal the bar.
    this.#update()
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#requestUpdate)
    window.removeEventListener('resize', this.#requestUpdate)
    this.#footerObserver?.disconnect()
  }

  #requestUpdate = () => {
    if (this.#ticking) return
    this.#ticking = true
    requestAnimationFrame(() => {
      this.#update()
      this.#ticking = false
    })
  }

  #update() {
    // Shown once the visitor has scrolled (or the page is too short to ever
    // trigger that), but never while the footer is on screen.
    const canScroll = document.documentElement.scrollHeight - window.innerHeight > 40
    const revealed = !canScroll || window.scrollY > 10
    this.#nav.classList.toggle('is-visible', revealed && !this.#footerVisible)
  }
}

if (!customElements.get('mobile-bottom-nav-reveal')) {
  customElements.define('mobile-bottom-nav-reveal', MobileBottomNavReveal)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class MobileNav {
  #toggle
  #nav
  #backdrop
  #closeButton
  #header

  constructor() {
    this.#toggle = document.querySelector('.header__menu-toggle')
    this.#nav = document.querySelector('.header__nav')
    this.#backdrop = document.getElementById('MenuDrawerBackdrop')
    this.#closeButton = document.getElementById('HeaderNavClose')
    this.#header = document.querySelector('.header')
    if (!this.#toggle || !this.#nav) return
    this.#toggle.addEventListener('click', () => this.#onToggle())
    this.#backdrop?.addEventListener('click', () => this.#setOpen(false))
    this.#closeButton?.addEventListener('click', () => this.#setOpen(false))
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  #onToggle() {
    this.#setOpen(!this.#nav.classList.contains('is-open'))
  }

  #setOpen(open) {
    this.#nav.classList.toggle('is-open', open)
    this.#toggle.setAttribute('aria-expanded', String(open))
    document.body.classList.toggle('menu-drawer-open', open)
    // .header__nav is nested inside .header, whose own z-index caps how high
    // the drawer can stack against siblings like the fixed mobile bottom nav —
    // elevate .header itself while the drawer is open so it escapes that cap.
    this.#header?.classList.toggle('header--drawer-open', open)

    if (this.#backdrop) {
      if (open) {
        this.#backdrop.hidden = false
        requestAnimationFrame(() => this.#backdrop.classList.add('is-open'))
      } else {
        this.#backdrop.classList.remove('is-open')
        window.setTimeout(() => {
          if (!this.#backdrop.classList.contains('is-open')) this.#backdrop.hidden = true
        }, 300)
      }
    }

    if (open) {
      this.#nav.querySelector('a, button')?.focus()
    }
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#nav.classList.contains('is-open')) {
      this.#setOpen(false)
      this.#toggle.focus()
    }
  }
}

class HeaderScroll {
  #header
  #announcementBar
  #announcementHeight = 0
  #isTransparent = false
  #lastY = 0
  #ticking = false
  #resizeTimer

  constructor() {
    this.#header = document.querySelector('.header')
    if (!this.#header) return
    this.#announcementBar = document.querySelector('.announcement-bar')

    this.#updatePadding()
    // On a hard refresh the browser can restore scroll position before this
    // ever ran, and #onScroll otherwise only fires from a real scroll event -
    // without this, a reload while already scrolled down left the header
    // visible with none of the --scrolled/--hidden state that scroll
    // position should imply (no background, wrong show/hide state) until
    // the next scroll.
    this.#onScroll()

    window.addEventListener('scroll', () => this.#requestTick(), { passive: true })
    // The header's height changes across breakpoints (nav link padding, logo
    // size), so the compensating body padding — set once above — would go
    // stale on any resize/orientation change without this.
    window.addEventListener('resize', () => this.#onResize(), { passive: true })

    // In the theme editor, adding/removing/reordering a section (e.g. the
    // announcement bar) re-renders in place with no page reload and no
    // resize event - without these, the padding this measured on load would
    // stay stale (leftover space after removing it, none after adding it).
    document.addEventListener('shopify:section:load', () => this.#onEditorChange())
    document.addEventListener('shopify:section:unload', () => this.#onEditorChange())
    document.addEventListener('shopify:section:reorder', () => this.#onEditorChange())
  }

  #onEditorChange() {
    this.#announcementBar = document.querySelector('.announcement-bar')
    this.#announcementHeight = 0
    if (this.#announcementBar) {
      this.#announcementBar.hidden = false
      this.#announcementBar.style.transform = ''
    }
    this.#updatePadding()
  }

  #updatePadding() {
    const announcementHeight = this.#announcementBar ? this.#announcementBar.offsetHeight : 0
    const headerHeight = this.#header.offsetHeight
    this.#announcementHeight = announcementHeight

    // --announcement-height drives .header { top } and .header--hidden transform.
    // Updated dynamically in #onScroll as the bar moves off screen.
    // --header-height: combined offset for body padding + other sections
    //   (sticky product info, search popup). Also updated in #onScroll.
    document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`)
    document.documentElement.style.setProperty('--header-height', `${headerHeight + announcementHeight}px`)

    this.#isTransparent = document.querySelector('.banner--transparent-header') !== null
    document.body.style.paddingTop = `${this.#isTransparent ? announcementHeight : headerHeight + announcementHeight}px`
  }

  #onResize() {
    window.clearTimeout(this.#resizeTimer)
    this.#resizeTimer = window.setTimeout(() => this.#updatePadding(), 150)
  }

  #requestTick() {
    if (this.#ticking) return
    this.#ticking = true
    requestAnimationFrame(() => {
      this.#onScroll()
      this.#ticking = false
    })
  }

  #onScroll() {
    const y = window.scrollY

    // Scroll the announcement bar off screen proportionally to scroll position
    // so it appears to be part of the normal page flow. Once fully gone, lock
    // it hidden permanently — it never comes back on scroll-up.
    // Guard: if offsetHeight measured as 0 (custom element not yet painted when
    // HeaderScroll constructed), re-measure here before acting.
    if (this.#announcementBar) {
      // Re-measure on first scroll tick if #updatePadding ran before the bar had height
      if (this.#announcementHeight === 0) {
        this.#announcementHeight = this.#announcementBar.offsetHeight
        if (this.#announcementHeight === 0) return
        document.documentElement.style.setProperty('--announcement-height', `${this.#announcementHeight}px`)
        document.documentElement.style.setProperty('--header-height', `${this.#header.offsetHeight + this.#announcementHeight}px`)
        document.body.style.paddingTop = `${this.#isTransparent ? this.#announcementHeight : this.#header.offsetHeight + this.#announcementHeight}px`
      }
      if (y >= this.#announcementHeight) {
        // Bar fully off screen — hide it for paint performance
        if (!this.#announcementBar.hidden) {
          this.#announcementBar.hidden = true
          this.#announcementBar.style.transform = ''
        }
        document.documentElement.style.setProperty('--announcement-height', '0px')
        document.documentElement.style.setProperty('--header-height', `${this.#header.offsetHeight}px`)
        document.body.style.paddingTop = `${this.#isTransparent ? 0 : this.#header.offsetHeight}px`
      } else {
        // Bar partially or fully in view — restore and position proportionally
        if (this.#announcementBar.hidden) {
          this.#announcementBar.hidden = false
        }
        const remaining = this.#announcementHeight - y
        this.#announcementBar.style.transform = y > 0 ? `translateY(-${y}px)` : ''
        document.documentElement.style.setProperty('--announcement-height', `${remaining}px`)
        document.documentElement.style.setProperty('--header-height', `${this.#header.offsetHeight + remaining}px`)
        document.body.style.paddingTop = `${this.#isTransparent ? remaining : this.#header.offsetHeight + remaining}px`
      }
    }

    this.#header.classList.toggle('header--scrolled', y > 10)

    // .header__nav and .header__search-popup are position:fixed but nested
    // inside .header — a transform on .header (from header--hidden) becomes
    // their containing block, dragging the open drawer/popup along with it
    // and breaking their fixed positioning. Never hide the header while
    // either is open.
    if (document.body.classList.contains('menu-drawer-open') || document.body.classList.contains('search-popup-open')) {
      this.#lastY = y
      return
    }

    if (y > 80 && y > this.#lastY) {
      this.#header.classList.add('header--hidden')
    } else {
      this.#header.classList.remove('header--hidden')
    }

    this.#lastY = y
  }
}

class CartToggle {
  constructor() {
    const toggle = document.getElementById('CartToggle')
    if (!toggle) return
    toggle.addEventListener('click', (event) => {
      event.preventDefault()
      document.dispatchEvent(new CustomEvent('cart:open'))
    })
  }
}

class CartIconBubble {
  #bubble

  constructor() {
    this.#bubble = document.getElementById('CartIconBubble')
    if (!this.#bubble) return
    document.addEventListener('cart:updated', (event) => this.#onCartUpdated(event))
  }

  #onCartUpdated(event) {
    const sections = event.detail?.sections
    if (!sections || !sections.header) return
    const doc = new DOMParser().parseFromString(sections.header, 'text/html')
    const updated = doc.getElementById('CartIconBubble')
    if (!updated) return
    this.#bubble.replaceWith(updated)
    this.#bubble = updated
  }
}

class PredictiveSearch {
  #toggle
  #popup
  #closeButton
  #backdrop
  #input
  #results
  #abortController
  #debounceTimer
  #lastFocused

  constructor() {
    this.#toggle = document.getElementById('SearchToggle')
    this.#popup = document.getElementById('HeaderSearchPopup')
    this.#closeButton = document.getElementById('HeaderSearchClose')
    this.#backdrop = document.getElementById('SearchPopupBackdrop')
    this.#input = document.getElementById('HeaderSearchInput')
    this.#results = document.getElementById('PredictiveSearchResults')
    if (!this.#toggle || !this.#popup || !this.#input || !this.#results) return

    this.#toggle.addEventListener('click', () => this.#open())
    this.#closeButton.addEventListener('click', () => this.#close())
    this.#backdrop?.addEventListener('click', () => this.#close())
    this.#input.addEventListener('input', () => this.#onInput())
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  #open() {
    this.#lastFocused = document.activeElement
    this.#popup.hidden = false
    if (this.#backdrop) this.#backdrop.hidden = false
    // The popup is nested inside .header and position: fixed - if the header
    // was already scrolled hidden (its own transform) before opening, that
    // transform is still the popup's containing block at this point, so it
    // needs clearing here too, not just guarded against going forward.
    document.querySelector('.header')?.classList.remove('header--hidden')
    requestAnimationFrame(() => {
      this.#popup.classList.add('is-open')
      this.#backdrop?.classList.add('is-open')
    })
    this.#toggle.setAttribute('aria-expanded', 'true')
    this.#input.focus()
    document.body.classList.add('search-popup-open')
  }

  #close() {
    this.#popup.classList.remove('is-open')
    this.#backdrop?.classList.remove('is-open')
    this.#toggle.setAttribute('aria-expanded', 'false')
    this.#abortController?.abort()
    document.body.classList.remove('search-popup-open')
    window.setTimeout(() => {
      if (!this.#popup.classList.contains('is-open')) {
        this.#popup.hidden = true
        if (this.#backdrop) this.#backdrop.hidden = true
      }
    }, 200)
    this.#lastFocused?.focus()
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#popup.classList.contains('is-open')) {
      this.#close()
    }
  }

  #onInput() {
    window.clearTimeout(this.#debounceTimer)
    const term = this.#input.value.trim()
    if (term.length < 2) {
      this.#results.innerHTML = ''
      return
    }
    this.#debounceTimer = window.setTimeout(() => this.#search(term), 300)
  }

  async #search(term) {
    this.#abortController?.abort()
    this.#abortController = new AbortController()

    try {
      const response = await fetch(
        `${window.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search`,
        { signal: this.#abortController.signal }
      )
      const text = await response.text()
      const doc = new DOMParser().parseFromString(text, 'text/html')
      const section = doc.getElementById('shopify-section-predictive-search')
      this.#results.innerHTML = section ? section.innerHTML : ''
    } catch (error) {
      if (error.name !== 'AbortError') this.#results.innerHTML = ''
    }
  }
}

// Transparent header only: solid background while a real mouse hovers the
// header. Touch is excluded on purpose - :hover sticks after a tap, which
// would leave the header solid over the hero until the next tap elsewhere.
class HeaderHover {
  constructor() {
    const header = document.querySelector('.header')
    if (!header) return
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)')
    header.addEventListener('mouseenter', () => {
      if (finePointer.matches) header.classList.add('header--hovered')
    })
    header.addEventListener('mouseleave', () => header.classList.remove('header--hovered'))
  }
}

class HeaderMenu {
  #items
  #desktopQuery
  #openPanel
  #openTrigger
  #backdrop
  #closeTimer
  #header

  constructor() {
    this.#items = Array.from(document.querySelectorAll('.header__nav-item.has-menu'))
    if (this.#items.length === 0) return
    this.#desktopQuery = window.matchMedia('(min-width: 990px)')
    this.#backdrop = document.getElementById('MegaMenuBackdrop')
    this.#header = document.querySelector('.header')
    this.#backdrop?.addEventListener('click', () => {
      if (this.#openPanel) this.#close(this.#openTrigger, this.#openPanel)
    })

    let firstMenu = null
    for (const item of this.#items) {
      const trigger = item.querySelector('.header__menu-trigger')
      const panel = item.querySelector('.header__menu-panel')
      if (!trigger || !panel) continue
      firstMenu ??= { trigger, panel }

      trigger.addEventListener('click', (event) => {
        if (this.#desktopQuery.matches) return
        event.preventDefault()
        this.#toggle(trigger, panel)
      })
      item.addEventListener('mouseenter', () => {
        if (!this.#desktopQuery.matches) return
        // Cancel any pending close from the item the pointer just left, so
        // switching between two adjacent triggers crossfades straight into
        // the new panel instead of both being briefly closed.
        window.clearTimeout(this.#closeTimer)
        this.#open(trigger, panel)
      })
      item.addEventListener('mouseleave', () => {
        if (!this.#desktopQuery.matches) return
        // The ~4px gap between nav items (.header__nav's gap) means the
        // pointer crosses a dead zone between triggers - closing instantly
        // here left a visible flash where neither panel was open while it
        // travelled that gap. A short delay gives the next item's
        // mouseenter a chance to cancel this before it fires.
        window.clearTimeout(this.#closeTimer)
        this.#closeTimer = window.setTimeout(() => this.#close(trigger, panel), 150)
      })
    }

    // Hovering the logo or the header icons opens the first mega-menu panel
    // too, so the whole header behaves as one hover target. Moving on to a
    // nav item swaps to that item's panel (its mouseenter above), and moving
    // between logo and icons keeps whatever is open (the pending close below
    // is cancelled by the next mouseenter).
    if (firstMenu) {
      for (const area of document.querySelectorAll('.header__logo, .header__icons')) {
        area.addEventListener('mouseenter', () => {
          if (!this.#desktopQuery.matches) return
          window.clearTimeout(this.#closeTimer)
          if (!this.#openPanel) this.#open(firstMenu.trigger, firstMenu.panel)
        })
        area.addEventListener('mouseleave', () => {
          if (!this.#desktopQuery.matches) return
          window.clearTimeout(this.#closeTimer)
          this.#closeTimer = window.setTimeout(() => {
            if (this.#openPanel) this.#close(this.#openTrigger, this.#openPanel)
          }, 150)
        })
      }
    }

    document.addEventListener('click', (event) => this.#onOutsideClick(event))
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  #toggle(trigger, panel) {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true'
    if (isOpen) {
      this.#close(trigger, panel)
    } else {
      this.#open(trigger, panel)
    }
  }

  #open(trigger, panel) {
    if (this.#openPanel && this.#openPanel !== panel) {
      // Every panel is absolutely positioned in the same spot below the
      // nav, so animating the outgoing panel's normal fade-out at the same
      // time the incoming one fades in made two different menus' content
      // visibly overlap for ~200ms - it read as a glitch, not a crossfade.
      // Skipping the outgoing panel's transition makes it disappear
      // instantly instead, so only one panel's content is ever on screen.
      const oldPanel = this.#openPanel
      oldPanel.classList.add('header__menu-panel--switching')
      this.#close(this.#openTrigger, oldPanel)
      requestAnimationFrame(() => oldPanel.classList.remove('header__menu-panel--switching'))
    }
    panel.classList.add('is-open')
    trigger.setAttribute('aria-expanded', 'true')
    this.#openPanel = panel
    this.#openTrigger = trigger
    if (this.#desktopQuery.matches) this.#header?.classList.add('header--menu-open')
    if (this.#desktopQuery.matches && this.#backdrop) {
      this.#backdrop.hidden = false
      requestAnimationFrame(() => this.#backdrop.classList.add('is-open'))
    }
  }

  #close(trigger, panel) {
    if (!trigger || !panel) return
    panel.classList.remove('is-open')
    trigger.setAttribute('aria-expanded', 'false')
    if (this.#openPanel === panel) {
      this.#openPanel = null
      this.#openTrigger = null
      this.#header?.classList.remove('header--menu-open')
      if (this.#backdrop) {
        this.#backdrop.classList.remove('is-open')
        window.setTimeout(() => {
          if (!this.#openPanel) this.#backdrop.hidden = true
        }, 200)
      }
    }
  }

  #onOutsideClick(event) {
    if (!this.#desktopQuery.matches || !this.#openPanel) return
    if (this.#openTrigger.closest('.header__nav-item').contains(event.target)) return
    this.#close(this.#openTrigger, this.#openPanel)
  }

  #onKeydown(event) {
    if (event.key !== 'Escape' || !this.#openPanel) return
    const trigger = this.#openTrigger
    this.#close(this.#openTrigger, this.#openPanel)
    trigger?.focus()
  }
}

// This script is already deferred, so the DOM (including every element
// these classes query for) is fully parsed by the time it runs - wrapping
// in DOMContentLoaded was redundant, and worse, pushed init past the entire
// deferred JS bundle finishing (DOMContentLoaded only fires once every
// deferred script across every section has run). HeaderScroll sets
// body's padding-top to compensate for the header's height; that delay
// left <main> briefly rendering un-padded at the top before jumping down
// once this finally ran - a real, measured layout shift (CLS), not just a
// theoretical one.
new MobileNav()
new HeaderScroll()
new CartToggle()
new CartIconBubble()
new PredictiveSearch()
new HeaderMenu()
new HeaderHover()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow extends HTMLElement {
  #track
  #slides
  #dots
  #prevBtn
  #nextBtn
  #index = 0
  #autoplayTimer
  #autoplayDelay
  #autoplayEnabled
  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  #pointerStartX

  connectedCallback() {
    this.#track = this.querySelector('[data-slideshow-track]')
    this.#slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'))
    this.#dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'))
    this.#prevBtn = this.querySelector('.hero-slideshow__arrow--prev')
    this.#nextBtn = this.querySelector('.hero-slideshow__arrow--next')
    this.#autoplayDelay = Number(this.dataset.autoplaySpeed) || 5000
    this.#autoplayEnabled = this.dataset.autoplay === 'true' && this.#slides.length > 1 && !this.#reducedMotion

    if (this.#slides.length < 2) return

    this.#prevBtn?.addEventListener('click', () => this.#userGoTo(this.#index - 1))
    this.#nextBtn?.addEventListener('click', () => this.#userGoTo(this.#index + 1))
    for (const dot of this.#dots) {
      dot.addEventListener('click', () => this.#userGoTo(Number(dot.dataset.index)))
    }

    this.addEventListener('pointerdown', (event) => (this.#pointerStartX = event.clientX))
    this.addEventListener('pointerup', (event) => this.#onSwipeEnd(event))
    this.addEventListener('mouseenter', () => this.#stopAutoplay())
    this.addEventListener('mouseleave', () => this.#startAutoplay())
    this.addEventListener('focusin', () => this.#stopAutoplay())
    this.addEventListener('focusout', () => this.#startAutoplay())
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.#stopAutoplay()
      else this.#startAutoplay()
    })

    this.#startAutoplay()
  }

  disconnectedCallback() {
    this.#stopAutoplay()
  }

  #onSwipeEnd(event) {
    if (this.#pointerStartX === undefined) return
    const deltaX = event.clientX - this.#pointerStartX
    this.#pointerStartX = undefined
    if (Math.abs(deltaX) < 40) return
    this.#userGoTo(deltaX < 0 ? this.#index + 1 : this.#index - 1)
  }

  #userGoTo(index) {
    this.#goTo(index)
    this.#stopAutoplay()
    this.#startAutoplay()
  }

  #goTo(index) {
    const nextIndex = (index + this.#slides.length) % this.#slides.length
    if (nextIndex === this.#index) return

    const current = this.#slides[this.#index]
    const next = this.#slides[nextIndex]
    current.classList.remove('is-active')
    current.inert = true
    next.classList.add('is-active')
    next.inert = false

    this.#dots[this.#index]?.classList.remove('is-active')
    this.#dots[nextIndex]?.classList.add('is-active')

    this.#index = nextIndex
  }

  #startAutoplay() {
    if (!this.#autoplayEnabled || this.#autoplayTimer) return
    this.#autoplayTimer = window.setInterval(() => this.#goTo(this.#index + 1), this.#autoplayDelay)
  }

  #stopAutoplay() {
    window.clearInterval(this.#autoplayTimer)
    this.#autoplayTimer = undefined
  }
}

if (!customElements.get('hero-slideshow-el')) {
  customElements.define('hero-slideshow-el', HeroSlideshow)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
class ImageComparison extends HTMLElement {
  #position = 50

  connectedCallback() {
    const initial = Number.parseFloat(this.dataset.initialPosition)
    this.#setPosition(Number.isNaN(initial) ? 50 : initial)

    this.addEventListener('pointerdown', this.#onPointerDown)
    this.addEventListener('pointermove', this.#onPointerMove)
    this.addEventListener('pointerup', this.#onPointerEnd)
    this.addEventListener('pointercancel', this.#onPointerEnd)
    this.addEventListener('keydown', this.#onKeydown)
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.#onPointerDown)
    this.removeEventListener('pointermove', this.#onPointerMove)
    this.removeEventListener('pointerup', this.#onPointerEnd)
    this.removeEventListener('pointercancel', this.#onPointerEnd)
    this.removeEventListener('keydown', this.#onKeydown)
  }

  #onPointerDown = (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return
    this.setPointerCapture(event.pointerId)
    // A touch that starts on the image may be the start of a vertical page
    // scroll, so only mouse/pen jump the divider immediately - touch waits
    // for an actual horizontal move.
    if (event.pointerType !== 'touch') {
      this.#setPositionFromEvent(event)
      event.preventDefault()
    }
  }

  #onPointerMove = (event) => {
    if (!this.hasPointerCapture(event.pointerId)) return
    this.#setPositionFromEvent(event)
  }

  #onPointerEnd = (event) => {
    if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId)
  }

  #onKeydown = (event) => {
    const step = event.shiftKey ? 10 : 2
    const targets = {
      ArrowLeft: this.#position - step,
      ArrowRight: this.#position + step,
      Home: 0,
      End: 100,
    }
    if (!(event.key in targets)) return
    this.#setPosition(targets[event.key])
    event.preventDefault()
  }

  #setPositionFromEvent(event) {
    const rect = this.getBoundingClientRect()
    this.#setPosition(((event.clientX - rect.left) / rect.width) * 100)
  }

  #setPosition(percent) {
    this.#position = Math.min(100, Math.max(0, percent))
    this.style.setProperty('--comparison-position', `${this.#position}%`)
    this.setAttribute('aria-valuenow', String(Math.round(this.#position)))
  }
}

if (!customElements.get('image-comparison')) {
  customElements.define('image-comparison', ImageComparison)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class ShareButton extends HTMLElement {
    constructor() {
      super()
      const button = this.querySelector('[data-share-button]')
      if (! button) return
      
      button.addEventListener('click', () => this.#onShare())
    }

    async #onShare() {
      const url = this.dataset.shareUrl
      const title = this.dataset.shareTitle
      if (navigator.share) {
        try {
          await navigator.share({title, url})
        } catch (error) { /* user dismissed the native share sheet */
        }
        return
      }
      try {
        await navigator.clipboard.writeText(url)
        const copied = this.querySelector('[data-share-copied]')
        if (copied) {
          copied.hidden = false
          window.setTimeout(() => {
            copied.hidden = true
          }, 2000)
        }
      } catch (error) { /* clipboard unavailable; no further fallback */
      }
    }
  }

  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class MainCart {
  #content
  #sectionId

  constructor() {
    this.#content = document.getElementById('MainCartContent')
    if (!this.#content) return
    this.#sectionId = this.#content.dataset.sectionId
    document.addEventListener('cart:updated', (event) => this.#onCartUpdated(event))
  }

  #onCartUpdated(event) {
    const sections = event.detail?.sections
    if (!sections || !sections[this.#sectionId]) return
    const newContent = new DOMParser()
      .parseFromString(sections[this.#sectionId], 'text/html')
      .getElementById('MainCartContent')
    if (newContent) this.#content.innerHTML = newContent.innerHTML
  }
}

document.addEventListener('DOMContentLoaded', () => new MainCart())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class CollectionFilters extends HTMLElement {
  #toggle
  #backdrop
  #panel
  #closeButton
  #lastFocused

  constructor() {
    super()
    this.#toggle = this.querySelector('.collection-filters__toggle')
    this.#backdrop = this.querySelector('[data-filters-backdrop]')
    this.#panel = this.querySelector('.collection-filters__panel')
    this.#closeButton = this.querySelector('[data-filters-close]')
    if (!this.#panel) return

    this.#toggle?.addEventListener('click', () => this.open())
    this.#closeButton?.addEventListener('click', () => this.close())
    this.#backdrop?.addEventListener('click', () => this.close())
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  open() {
    this.#lastFocused = document.activeElement
    this.#panel.hidden = false
    if (this.#backdrop) this.#backdrop.hidden = false
    requestAnimationFrame(() => {
      this.#panel.classList.add('is-open')
      this.#backdrop?.classList.add('is-open')
    })
    this.#toggle?.setAttribute('aria-expanded', 'true')
    document.body.classList.add('collection-filters-open')
    this.#closeButton?.focus()
  }

  close() {
    this.#panel.classList.remove('is-open')
    this.#backdrop?.classList.remove('is-open')
    this.#toggle?.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('collection-filters-open')
    window.setTimeout(() => {
      if (!this.#panel.classList.contains('is-open')) {
        this.#panel.hidden = true
        if (this.#backdrop) this.#backdrop.hidden = true
      }
    }, 300)
    this.#lastFocused?.focus()
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#panel.classList.contains('is-open')) this.close()
  }
}

class PriceRangeSlider extends HTMLElement {
  #minThumb
  #maxThumb
  #minInput
  #maxInput
  #progress
  #min
  #max

  constructor() {
    super()
    this.#minThumb = this.querySelector('[data-price-thumb-min]')
    this.#maxThumb = this.querySelector('[data-price-thumb-max]')
    this.#minInput = this.querySelector('[data-price-input-min]')
    this.#maxInput = this.querySelector('[data-price-input-max]')
    this.#progress = this.querySelector('[data-price-progress]')
    if (!this.#minThumb || !this.#maxThumb) return

    this.#min = Number(this.#minThumb.min)
    this.#max = Number(this.#minThumb.max)

    this.#minThumb.addEventListener('input', () => this.#onThumbInput('min'))
    this.#maxThumb.addEventListener('input', () => this.#onThumbInput('max'))
    this.#minThumb.addEventListener('pointerdown', () => this.#raise('min'))
    this.#maxThumb.addEventListener('pointerdown', () => this.#raise('max'))
    this.#minInput?.addEventListener('change', () => this.#onTextInput('min'))
    this.#maxInput?.addEventListener('change', () => this.#onTextInput('max'))

    this.#updateProgress()
  }

  #raise(which) {
    this.#minThumb.style.zIndex = which === 'min' ? '5' : '1'
    this.#maxThumb.style.zIndex = which === 'max' ? '5' : '1'
  }

  #onThumbInput(which) {
    let minVal = Number(this.#minThumb.value)
    let maxVal = Number(this.#maxThumb.value)
    if (minVal > maxVal) {
      if (which === 'min') {
        minVal = maxVal
        this.#minThumb.value = String(minVal)
      } else {
        maxVal = minVal
        this.#maxThumb.value = String(maxVal)
      }
    }
    if (this.#minInput) this.#minInput.value = minVal.toFixed(2)
    if (this.#maxInput) this.#maxInput.value = maxVal.toFixed(2)
    this.#updateProgress()
  }

  #onTextInput(which) {
    const raw = which === 'min' ? this.#minInput.value : this.#maxInput.value
    let value = Number.parseFloat(String(raw).replace(',', '.'))
    if (Number.isNaN(value)) value = which === 'min' ? this.#min : this.#max
    value = Math.min(Math.max(value, this.#min), this.#max)

    if (which === 'min') {
      value = Math.min(value, Number(this.#maxThumb.value))
      this.#minThumb.value = String(value)
      this.#minInput.value = value.toFixed(2)
    } else {
      value = Math.max(value, Number(this.#minThumb.value))
      this.#maxThumb.value = String(value)
      this.#maxInput.value = value.toFixed(2)
    }
    this.#updateProgress()
  }

  #updateProgress() {
    if (!this.#progress) return
    const min = Number(this.#minThumb.value)
    const max = Number(this.#maxThumb.value)
    const range = this.#max - this.#min || 1
    const left = ((min - this.#min) / range) * 100
    const right = 100 - ((max - this.#min) / range) * 100
    this.#progress.style.left = `${left}%`
    this.#progress.style.right = `${right}%`
  }
}

class CollectionResults extends HTMLElement {
  #sectionId
  #grid
  #count
  #filtersPanel

  constructor() {
    super()
    this.#sectionId = this.dataset.sectionId
    this.#grid = this.querySelector('[data-grid-container]')
    this.#count = this.querySelector('[data-product-count]')
    this.#filtersPanel = this.querySelector('[data-filters-panel]')

    this.addEventListener('change', (event) => this.#onChange(event))
    this.addEventListener('click', (event) => this.#onClick(event))
    window.addEventListener('popstate', () => this.#fetchAndRender(window.location.href, false))
  }

  #onChange(event) {
    const target = event.target
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return

    if (target.hasAttribute('data-nav-url')) {
      if (target.checked) window.location.href = target.dataset.navUrl
      return
    }

    if (
      target.matches('select[name="sort_by"]') ||
      target.matches('input[type="checkbox"]') ||
      target.matches('input[type="range"]') ||
      target.matches('[data-price-input-min], [data-price-input-max]')
    ) {
      this.#submitForm()
    }
  }

  #onClick(event) {
    const priceRemove = event.target.closest('[data-price-pill] .active-filters__remove')
    if (priceRemove) {
      const pill = priceRemove.closest('[data-price-pill]')
      const form = this.querySelector('form')
      const minInput = form?.querySelector(`[name="${pill.dataset.minName}"]`)
      const maxInput = form?.querySelector(`[name="${pill.dataset.maxName}"]`)
      if (minInput) minInput.value = ''
      if (maxInput) maxInput.value = ''
      this.#submitForm()
      return
    }

    const link = event.target.closest(
      '.active-filters__pill[href], .active-filters__clear-all[href], .pagination__link[href]'
    )
    if (link) {
      event.preventDefault()
      this.#fetchAndRender(link.href)
    }
  }

  #submitForm() {
    const form = this.querySelector('form')
    if (!form) return
    const params = new URLSearchParams(new FormData(form))

    // The price slider always has a value, even at its full default range — don't
    // submit it as an active filter (and show a misleading pill) unless narrowed.
    const minThumb = this.querySelector('[data-price-thumb-min]')
    const maxThumb = this.querySelector('[data-price-thumb-max]')
    const minInput = this.querySelector('[data-price-input-min]')
    const maxInput = this.querySelector('[data-price-input-max]')
    if (minThumb && maxThumb && minInput && maxInput) {
      const atDefaultRange =
        Number(minInput.value || 0) <= Number(minThumb.min) &&
        Number(maxInput.value || maxThumb.max) >= Number(maxThumb.max)
      if (atDefaultRange) {
        params.delete(minInput.name)
        params.delete(maxInput.name)
      }
    }

    for (const [key, value] of [...params]) {
      if (value === '') params.delete(key)
    }
    const query = params.toString()
    const url = query ? `${window.location.pathname}?${query}` : window.location.pathname
    this.#fetchAndRender(url)
  }

  async #fetchAndRender(url, pushHistory = true) {
    this.#grid?.classList.add('is-loading')
    const separator = url.includes('?') ? '&' : '?'

    // The panel swap below replaces every <details> wholesale, so any group
    // the shopper had manually expanded (that isn't also "active", which is
    // the only thing the freshly-rendered HTML knows to open) would otherwise
    // silently collapse on every filter change.
    const openParams = new Set(
      Array.from(this.querySelectorAll('[data-filters-panel] details[open]')).map((details) => details.dataset.filterParam)
    )

    try {
      const response = await fetch(`${url}${separator}section_id=${this.#sectionId}`)
      const text = await response.text()
      const doc = new DOMParser().parseFromString(text, 'text/html')

      const newGrid = doc.querySelector('[data-grid-container]')
      if (newGrid && this.#grid) {
        this.#grid.innerHTML = newGrid.innerHTML
        // Product cards now render Loox's .loox-rating markup instead of
        // Air Reviews. Unlike Air Reviews, Loox doesn't expose a documented
        // global to re-scan freshly swapped-in DOM (their script only scans
        // once on page load), so stars on filtered-in cards may stay empty
        // until Loox ships one - verify this after filtering and, if blank,
        // ask Loox support for the equivalent of avadaAirReviewRerender.
      }

      const newCount = doc.querySelector('[data-product-count]')
      if (newCount && this.#count) this.#count.innerHTML = newCount.innerHTML

      const newFiltersPanel = doc.querySelector('[data-filters-panel]')
      if (newFiltersPanel && this.#filtersPanel) {
        this.#filtersPanel.innerHTML = newFiltersPanel.innerHTML
        for (const details of this.#filtersPanel.querySelectorAll('details[data-filter-param]')) {
          if (openParams.has(details.dataset.filterParam)) details.open = true
        }
      }

      if (pushHistory) history.pushState({}, '', url)
    } finally {
      this.#grid?.classList.remove('is-loading')
    }
  }
}

customElements.define('collection-filters', CollectionFilters)
customElements.define('price-range-slider', PriceRangeSlider)
customElements.define('collection-results', CollectionResults)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faqs"] && !Shopify.designMode) return;
  try {
    
class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-faq-trigger]');
    if (!trigger) return;

    const item = trigger.closest('[data-faq-item]');
    if (!item) return;

    const willOpen = !item.hasAttribute('data-faq-open');

    // Each category renders its own <faq-accordion>, so only siblings in the same category close.
    for (const other of this.querySelectorAll('[data-faq-item]')) {
      if (other === item) continue;
      other.removeAttribute('data-faq-open');
      other.querySelector('[data-faq-trigger]')?.setAttribute('aria-expanded', 'false');
    }

    item.toggleAttribute('data-faq-open', willOpen);
    trigger.setAttribute('aria-expanded', String(willOpen));
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
// Built via fromCharCode, not a literal, so this section's own script block
// doesn't mistake this fallback money-format placeholder for a Liquid output
// tag - a literal double-brace pair anywhere in this block breaks the parser.
const DEFAULT_MONEY_FORMAT = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125)

class ProductInfo extends HTMLElement {
  #form
  #variantIdInput
  #sampleAddonInput
  #sampleAddonsList
  #sampleAddonsItems
  #sampleAddonsDots
  #sampleAddonsPrevBtn
  #sampleAddonsNextBtn
  #sampleAddonsScrollTimer
  #variants
  #currentVariant
  #sectionId
  #url
  #moneyFormat
  #gallery
  #pendingSubmit = false
  #syncTimer
  #stickyObserver
  #footerObserver

  constructor() {
    super()
    this.#form = this.querySelector('[data-product-form]')
    if (!this.#form) return

    this.#variantIdInput = this.#form.querySelector('[data-product-form-variant-id]')
    this.#sampleAddonInput = this.#form.querySelector('[data-sample-addon-value]')
    this.#sampleAddonsList = this.#form.querySelector('[data-sample-addons-list]')
    this.#sectionId = this.dataset.sectionId
    this.#url = this.dataset.productUrl
    this.#moneyFormat = this.dataset.moneyFormat || DEFAULT_MONEY_FORMAT
    this.#gallery = this.querySelector('product-gallery')

    const variantsScript = this.querySelector('[data-product-variants]')
    this.#variants = variantsScript ? JSON.parse(variantsScript.textContent) : []
    this.#currentVariant =
      this.#variants.find((variant) => String(variant.id) === this.#variantIdInput.value) || this.#variants[0]

    this.addEventListener('click', (event) => this.#onClick(event))
    this.addEventListener('change', (event) => this.#onChange(event))
    this.addEventListener('input', (event) => this.#onInput(event))
    this.#form.addEventListener('submit', () => {
      this.#pendingSubmit = true
    })
    this.#form.addEventListener('cart:complete', () => {
      this.#updateAvailability(this.#currentVariant)
      this.#updateStickyCart(this.#currentVariant)
    })

    document.addEventListener('cart:updated', () => this.#onCartUpdated())
    document.addEventListener('cart:error', (event) => this.#onCartError(event))

    this.#initStickyCartBar()
    this.#syncQuantityButtonStates()
    this.#initSampleAddonsSlider()
  }

  // Dots/arrows only ever matter on mobile (the list is a stacked,
  // non-scrolling column on desktop - see the @media rule in this
  // section's stylesheet), but the listener is cheap to keep attached
  // unconditionally rather than wiring/unwiring it across a resize.
  #initSampleAddonsSlider() {
    if (!this.#sampleAddonsList) return
    this.#sampleAddonsItems = Array.from(this.#sampleAddonsList.querySelectorAll('[data-sample-addons-item]'))
    this.#sampleAddonsDots = Array.from(this.querySelectorAll('[data-sample-addons-dot]'))
    this.#sampleAddonsPrevBtn = this.querySelector('[data-sample-addons-prev]')
    this.#sampleAddonsNextBtn = this.querySelector('[data-sample-addons-next]')
    if (this.#sampleAddonsItems.length < 2) return

    this.#sampleAddonsList.addEventListener('scroll', () => this.#onSampleAddonsScroll(), { passive: true })
    this.#updateSampleAddonsControls(0)
  }

  #onClick(event) {
    const valueButton = event.target.closest('[data-variant-value]')
    if (valueButton) {
      this.#onVariantValueClick(valueButton)
      return
    }
    const decrease = event.target.closest('[data-quantity-decrease]')
    if (decrease) {
      this.#stepQuantity(decrease, -1)
      return
    }
    const increase = event.target.closest('[data-quantity-increase]')
    if (increase) {
      this.#stepQuantity(increase, 1)
      return
    }
    const accordionTrigger = event.target.closest('[data-accordion-trigger]')
    if (accordionTrigger) {
      this.#onAccordionTriggerClick(accordionTrigger)
      return
    }
    const prevBtn = event.target.closest('[data-sample-addons-prev]')
    if (prevBtn) {
      this.#scrollSampleAddonsBy(-1)
      return
    }
    const nextBtn = event.target.closest('[data-sample-addons-next]')
    if (nextBtn) {
      this.#scrollSampleAddonsBy(1)
      return
    }
    const dot = event.target.closest('[data-sample-addons-dot]')
    if (dot) {
      this.#scrollSampleAddonsTo(Number(dot.dataset.index))
    }
  }

  #scrollSampleAddonsBy(direction) {
    const current = this.#sampleAddonsItems.findIndex((item) => this.#isSampleAddonsItemActive(item))
    this.#scrollSampleAddonsTo((current === -1 ? 0 : current) + direction)
  }

  #scrollSampleAddonsTo(index) {
    const clamped = Math.max(0, Math.min(this.#sampleAddonsItems.length - 1, index))
    const item = this.#sampleAddonsItems[clamped]
    if (!item) return
    // Update the dot/arrow state immediately rather than waiting for the
    // smooth-scroll animation to finish and #onSampleAddonsScroll to pick
    // it up - a click is an explicit "go here" intent, so there's no
    // reason for the indicator to lag behind it the way it reasonably
    // does for a swipe (where the destination isn't known until the
    // gesture settles).
    this.#updateSampleAddonsControls(clamped)
    this.#sampleAddonsList.scrollTo({ left: item.offsetLeft - this.#sampleAddonsList.offsetLeft, behavior: 'smooth' })
  }

  #isSampleAddonsItemActive(item) {
    const listRect = this.#sampleAddonsList.getBoundingClientRect()
    const itemRect = item.getBoundingClientRect()
    return Math.abs(itemRect.left - listRect.left) < itemRect.width / 2
  }

  #onSampleAddonsScroll() {
    // Only covers swipe - #scrollSampleAddonsTo already updates immediately
    // for arrow/dot clicks. 40ms is just enough to avoid thrashing between
    // two items mid-drag without feeling laggy once the swipe settles.
    clearTimeout(this.#sampleAddonsScrollTimer)
    this.#sampleAddonsScrollTimer = setTimeout(() => {
      const index = this.#sampleAddonsItems.findIndex((item) => this.#isSampleAddonsItemActive(item))
      this.#updateSampleAddonsControls(index === -1 ? 0 : index)
    }, 40)
  }

  #updateSampleAddonsControls(index) {
    for (const [i, dot] of this.#sampleAddonsDots.entries()) {
      dot.classList.toggle('is-active', i === index)
    }
    if (this.#sampleAddonsPrevBtn) this.#sampleAddonsPrevBtn.disabled = index === 0
    if (this.#sampleAddonsNextBtn) this.#sampleAddonsNextBtn.disabled = index === this.#sampleAddonsItems.length - 1
  }

  #onAccordionTriggerClick(trigger) {
    const item = trigger.closest('[data-accordion-item]')
    const willOpen = !item.hasAttribute('data-accordion-open')

    // Only one accordion item open at a time: close every sibling first.
    for (const other of this.querySelectorAll('[data-accordion-item]')) {
      if (other === item) continue
      other.removeAttribute('data-accordion-open')
      other.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', 'false')
    }

    item.toggleAttribute('data-accordion-open', willOpen)
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
  }

  #onChange(event) {
    if (event.target.matches('[data-quantity-input]')) {
      this.#clampQuantityInput(event.target)
      this.#clearCartError()
    }
    if (event.target.matches('[data-sample-addon-checkbox]')) {
      this.#onSampleAddonChange(event.target)
    }
  }

  // Checkboxes, not radios: a native radio can't be unchecked by re-clicking
  // it, and "no sample selected" needs to stay reachable. This keeps exactly
  // one checked (or none) and mirrors the pick into the hidden
  // properties[_sample_variant_id] input that rides along on the next
  // /cart/add.js submit - see the reconciliation logic in global.js for how
  // that single property on the parent line drives the whole feature.
  #onSampleAddonChange(checkbox) {
    if (!this.#sampleAddonInput) return
    const group = checkbox.closest('[data-sample-addons-list]')
    if (checkbox.checked) {
      for (const other of group.querySelectorAll('[data-sample-addon-checkbox]')) {
        if (other !== checkbox) other.checked = false
      }
      this.#sampleAddonInput.value = checkbox.value
    } else {
      this.#sampleAddonInput.value = ''
    }
  }

  #onInput(event) {
    if (event.target.matches('[data-quantity-input]')) {
      this.#clearCartError()
    }
  }

  #onVariantValueClick(button) {
    if (button.classList.contains('is-selected')) return

    const position = Number(button.dataset.optionPosition)
    const value = button.dataset.value
    const group = button.closest('.variant-picker__option')

    for (const other of group.querySelectorAll('[data-variant-value]')) {
      const isThis = other === button
      other.classList.toggle('is-selected', isThis)
      other.setAttribute('aria-pressed', isThis ? 'true' : 'false')
    }
    const label = group.querySelector('[data-selected-value]')
    if (label) label.textContent = value

    const selectedOptions = this.#getSelectedOptions()
    selectedOptions[position - 1] = value

    this.#updateValueAvailability(selectedOptions)

    const matchedVariant = this.#variants.find((variant) =>
      variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
    )
    if (matchedVariant) this.#setVariant(matchedVariant)
  }

  #getSelectedOptions() {
    const options = []
    for (const group of this.querySelectorAll('.variant-picker__option')) {
      const position = Number(group.dataset.optionPosition)
      const selected = group.querySelector('[data-variant-value].is-selected')
      options[position - 1] = selected ? selected.dataset.value : this.#currentVariant.options[position - 1]
    }
    return options
  }

  #updateValueAvailability(selectedOptions) {
    for (const button of this.querySelectorAll('[data-variant-value]')) {
      const position = Number(button.dataset.optionPosition)
      const candidate = selectedOptions.slice()
      candidate[position - 1] = button.dataset.value
      const match = this.#variants.find((variant) =>
        variant.options.every((optionValue, index) => optionValue === candidate[index])
      )
      const available = !match || match.available
      button.classList.toggle('is-unavailable', !available)
    }
  }

  #setVariant(variant) {
    this.#currentVariant = variant
    this.#variantIdInput.value = variant.id
    this.#variantIdInput.dispatchEvent(new Event('change', { bubbles: true }))

    if (this.#url) {
      const url = new URL(this.#url, window.location.origin)
      url.searchParams.set('variant', variant.id)
      window.history.replaceState({}, '', `${url.pathname}${url.search}`)
    }

    this.#updatePrice(variant)
    this.#updateAvailability(variant)
    this.#updateStickyCart(variant)
    this.#gallery?.onVariantChange(variant)
    this.#queueServerSync(variant.id)

    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }))
  }

  #updatePrice(variant) {
    const onSale = variant.compare_at_price > variant.price
    for (const wrapper of this.querySelectorAll('[data-product-price]')) {
      wrapper.classList.toggle('price--on-sale', onSale)

      const current = wrapper.querySelector('[data-price-current]')
      if (current) current.textContent = this.#formatMoney(variant.price)

      const compare = wrapper.querySelector('[data-price-compare]')
      if (compare) {
        compare.textContent = this.#formatMoney(variant.compare_at_price)
        compare.hidden = !onSale
      }

      const badge = wrapper.querySelector('[data-price-badge]')
      if (badge) {
        badge.hidden = !onSale
        if (onSale) {
          const format = wrapper.dataset.savingsFormat
          badge.textContent =
            format === 'amount'
              ? this.#formatMoney(variant.compare_at_price - variant.price)
              : `${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%`
        }
      }
    }
  }

  #updateAvailability(variant) {
    for (const box of this.querySelectorAll('[data-buy-box]')) {
      const submit = box.querySelector('[data-add-to-cart]')
      if (submit) {
        submit.disabled = !variant.available || this.#form.dataset.cartSubmitting === 'true'
        const text = submit.querySelector('[data-add-to-cart-text]')
        if (text) text.textContent = variant.available ? submit.dataset.labelAvailable : submit.dataset.labelUnavailable
      }
      const payment = box.querySelector('[data-payment-button]')
      if (payment) payment.hidden = !variant.available
      const waitlist = box.querySelector('[data-waitlist-button]')
      if (waitlist) waitlist.hidden = variant.available
    }
  }

  #updateStickyCart(variant) {
    const bar = this.querySelector('[data-sticky-cart]')
    if (!bar) return
    const submit = bar.querySelector('[data-sticky-add-to-cart]')
    if (submit) {
      submit.disabled = !variant.available || this.#form.dataset.cartSubmitting === 'true'
      const text = submit.querySelector('[data-sticky-add-to-cart-text]')
      if (text) text.textContent = variant.available ? submit.dataset.labelAvailable : submit.dataset.labelUnavailable
      const price = submit.querySelector('[data-sticky-price]')
      if (price) price.textContent = this.#formatMoney(variant.price)
    }
  }

  #queueServerSync(variantId) {
    window.clearTimeout(this.#syncTimer)
    this.#syncTimer = window.setTimeout(() => this.#syncFromServer(variantId), 300)
  }

  async #syncFromServer(variantId) {
    if (!this.#url) return
    try {
      const response = await fetch(`${this.#url}?variant=${variantId}&section_id=${this.#sectionId}`)
      if (!response.ok) return
      const text = await response.text()
      if (this.#currentVariant.id !== variantId) return

      const doc = new DOMParser().parseFromString(text, 'text/html')
      const freshBox = doc.querySelector('[data-buy-box]')
      if (!freshBox) return

      for (const input of this.querySelectorAll('[data-quantity-input]')) {
        if (freshBox.dataset.qtyMin) input.min = freshBox.dataset.qtyMin
        if (freshBox.dataset.qtyMax) {
          input.max = freshBox.dataset.qtyMax
        } else {
          input.removeAttribute('max')
        }
        if (freshBox.dataset.qtyIncrement) input.step = freshBox.dataset.qtyIncrement
        this.#clampQuantityInput(input)
      }
      this.#syncQuantityButtonStates()

      const freshPayment = freshBox.querySelector('[data-payment-button]')
      if (freshPayment && this.#currentVariant.available) {
        for (const wrap of this.querySelectorAll('[data-payment-button]')) {
          wrap.innerHTML = freshPayment.innerHTML
        }
      }
    } catch (error) {
      /* silent: the payment button/quantity rules simply keep their last-known state */
    }
  }

  #stepQuantity(button, direction) {
    const wrap = button.closest('[data-quantity-selector]')
    const input = wrap.querySelector('[data-quantity-input]')
    const step = Number(input.step) || 1
    input.value = Number(input.value || 0) + step * direction
    this.#clampQuantityInput(input)
    this.#clearCartError()
  }

  #clampQuantityInput(input) {
    const min = Number(input.min) || 1
    const max = input.max !== '' ? Number(input.max) : null
    const step = Number(input.step) || 1
    let value = Number(input.value) || min
    if (value < min) value = min
    if (max !== null && value > max) value = max
    const stepsFromMin = Math.round((value - min) / step)
    value = min + stepsFromMin * step
    if (max !== null && value > max) value -= step
    input.value = value
    this.#syncQuantityButtonStates()
  }

  #syncQuantityButtonStates() {
    for (const wrap of this.querySelectorAll('[data-quantity-selector]')) {
      const input = wrap.querySelector('[data-quantity-input]')
      const decrease = wrap.querySelector('[data-quantity-decrease]')
      const increase = wrap.querySelector('[data-quantity-increase]')
      const min = Number(input.min) || 1
      const max = input.max !== '' ? Number(input.max) : null
      const value = Number(input.value)
      if (decrease) decrease.disabled = value <= min
      if (increase) increase.disabled = max !== null && value >= max
    }
  }

  #clearCartError() {
    for (const error of this.querySelectorAll('[data-cart-error]')) {
      error.hidden = true
      error.textContent = ''
    }
  }

  #onCartUpdated() {
    if (!this.#pendingSubmit) return
    this.#pendingSubmit = false
    this.#clearCartError()
    this.#resetSampleAddon()
  }

  #resetSampleAddon() {
    if (!this.#sampleAddonInput) return
    this.#sampleAddonInput.value = ''
    for (const checkbox of this.querySelectorAll('[data-sample-addon-checkbox]')) {
      checkbox.checked = false
    }
  }

  #onCartError(event) {
    if (!this.#pendingSubmit) return
    this.#pendingSubmit = false
    const detail = event.detail
    const message = detail?.description || detail?.message || this.dataset.labelCartError
    for (const error of this.querySelectorAll('[data-cart-error]')) {
      error.textContent = message
      error.hidden = false
    }
  }

  #formatMoney(cents) {
    const amount = (cents / 100).toFixed(2)
    const [dollars, decimalPart] = amount.split('.')
    const withComma = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return this.#moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${withComma}.${decimalPart}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma)
  }

  #initStickyCartBar() {
    const bar = this.querySelector('[data-sticky-cart]')
    const buyBox = this.querySelector('[data-buy-box]')
    if (!bar || !buyBox || !('IntersectionObserver' in window)) return

    let pastBuyBox = false
    let footerVisible = false
    const render = () => this.#toggleStickyCart(bar, pastBuyBox && !footerVisible)

    this.#stickyObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0
        render()
      },
      { threshold: 0 }
    )
    this.#stickyObserver.observe(buyBox)

    // Hide the bar once the footer scrolls into view so it never sits on top
    // of it, and bring it back once the footer scrolls back out of view.
    const footer = document.querySelector('.shopify-section-group-footer-group')
    if (footer) {
      this.#footerObserver = new IntersectionObserver(
        (entries) => {
          const [entry] = entries
          footerVisible = entry.isIntersecting
          render()
        },
        { threshold: 0 }
      )
      this.#footerObserver.observe(footer)
    }
  }

  #toggleStickyCart(bar, show) {
    if (show) {
      bar.hidden = false
      window.requestAnimationFrame(() => bar.classList.add('is-visible'))
    } else {
      bar.classList.remove('is-visible')
      window.setTimeout(() => {
        if (!bar.classList.contains('is-visible')) bar.hidden = true
      }, 250)
    }
  }
}

class ProductGallery extends HTMLElement {
  #stage
  #track
  #slides
  #thumbs
  #variantMedia
  #activeIndex = 0
  #dragStartX = 0
  #dragDeltaX = 0
  #isDragging = false
  #pointerId = null
  #suppressClick = false

  constructor() {
    super()
    this.#stage = this.querySelector('[data-gallery-stage]')
    this.#track = this.querySelector('[data-gallery-track]')
    this.#slides = Array.from(this.querySelectorAll('[data-gallery-slide]'))
    this.#thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'))
    const mediaScript = this.querySelector('[data-variant-media]')
    this.#variantMedia = mediaScript ? JSON.parse(mediaScript.textContent) : {}

    this.addEventListener('click', (event) => this.#onClick(event))

    if (this.#track && this.#slides.length > 1) {
      this.#track.addEventListener('pointerdown', (event) => this.#onPointerDown(event))
      this.#track.addEventListener('pointermove', (event) => this.#onPointerMove(event))
      this.#track.addEventListener('pointerup', (event) => this.#onPointerEnd(event))
      this.#track.addEventListener('pointercancel', (event) => this.#onPointerEnd(event))
    }
  }

  #onClick(event) {
    // A drag gesture also fires a click on release; swallow just that one so
    // it doesn't land on a thumb/nav button under the pointer.
    if (this.#suppressClick) {
      this.#suppressClick = false
      return
    }
    const thumb = event.target.closest('[data-gallery-thumb]')
    if (thumb) {
      this.showMedia(thumb.dataset.mediaId)
      return
    }
    if (event.target.closest('[data-gallery-prev]')) {
      this.#step(-1)
      return
    }
    if (event.target.closest('[data-gallery-next]')) {
      this.#step(1)
    }
  }

  #onPointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return
    this.#isDragging = true
    this.#pointerId = event.pointerId
    this.#dragStartX = event.clientX
    this.#dragDeltaX = 0
    this.#track.classList.add('is-dragging')
    this.#track.setPointerCapture(event.pointerId)
  }

  #onPointerMove(event) {
    if (!this.#isDragging || event.pointerId !== this.#pointerId) return
    this.#dragDeltaX = event.clientX - this.#dragStartX
    const percent = (this.#dragDeltaX / this.#stage.getBoundingClientRect().width) * 100
    this.#track.style.transform = `translateX(calc(${-this.#activeIndex * 100}% + ${percent}%))`
  }

  #onPointerEnd(event) {
    if (!this.#isDragging || event.pointerId !== this.#pointerId) return
    this.#isDragging = false
    this.#track.classList.remove('is-dragging')
    this.#track.releasePointerCapture(event.pointerId)

    const width = this.#stage.getBoundingClientRect().width
    const threshold = width * 0.15
    if (this.#dragDeltaX > threshold) {
      this.#step(-1)
    } else if (this.#dragDeltaX < -threshold) {
      this.#step(1)
    } else {
      this.#renderPosition()
    }

    if (Math.abs(this.#dragDeltaX) > 5) this.#suppressClick = true
    this.#dragDeltaX = 0
  }

  #step(direction) {
    const nextIndex = (this.#activeIndex + direction + this.#slides.length) % this.#slides.length
    this.#setActiveIndex(nextIndex)
  }

  #renderPosition() {
    this.#track.style.transform = `translateX(${-this.#activeIndex * 100}%)`
  }

  #setActiveIndex(index) {
    this.#activeIndex = index
    const slide = this.#slides[index]
    this.#renderPosition()
    for (const candidate of this.#slides) {
      candidate.classList.toggle('product-gallery__slide--active', candidate === slide)
    }
    for (const thumb of this.#thumbs) {
      const active = thumb.dataset.mediaId === slide.dataset.mediaId
      thumb.classList.toggle('is-active', active)
      thumb.setAttribute('aria-selected', active ? 'true' : 'false')
    }
  }

  showMedia(mediaId) {
    if (!mediaId || mediaId === '0') return
    const index = this.#slides.findIndex((candidate) => candidate.dataset.mediaId === mediaId)
    if (index === -1) return
    this.#setActiveIndex(index)
  }

  onVariantChange(variant) {
    const mediaId = this.#variantMedia[String(variant.id)]
    if (mediaId) this.showMedia(String(mediaId))
  }
}

class ShareButton extends HTMLElement {
  constructor() {
    super()
    const button = this.querySelector('[data-share-button]')
    if (!button) return
    button.addEventListener('click', () => this.#onShare())
  }

  async #onShare() {
    const url = this.dataset.shareUrl
    const title = this.dataset.shareTitle
    if (navigator.share) {
      try {
        await navigator.share({ title, url })
      } catch (error) {
        /* user dismissed the native share sheet */
      }
      return
    }
    try {
      await navigator.clipboard.writeText(url)
      const copied = this.querySelector('[data-share-copied]')
      if (copied) {
        copied.hidden = false
        window.setTimeout(() => {
          copied.hidden = true
        }, 2000)
      }
    } catch (error) {
      /* clipboard unavailable; no further fallback */
    }
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery)
}
if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}
if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
class SearchFilters extends HTMLElement {
  #toggle
  #backdrop
  #panel
  #closeButton
  #lastFocused

  constructor() {
    super()
    this.#toggle = this.querySelector('.collection-filters__toggle')
    this.#backdrop = this.querySelector('[data-filters-backdrop]')
    this.#panel = this.querySelector('.collection-filters__panel')
    this.#closeButton = this.querySelector('[data-filters-close]')
    if (!this.#panel) return

    this.#toggle?.addEventListener('click', () => this.open())
    this.#closeButton?.addEventListener('click', () => this.close())
    this.#backdrop?.addEventListener('click', () => this.close())
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  open() {
    this.#lastFocused = document.activeElement
    this.#panel.hidden = false
    if (this.#backdrop) this.#backdrop.hidden = false
    requestAnimationFrame(() => {
      this.#panel.classList.add('is-open')
      this.#backdrop?.classList.add('is-open')
    })
    this.#toggle?.setAttribute('aria-expanded', 'true')
    document.body.classList.add('search-filters-open')
    this.#closeButton?.focus()
  }

  close() {
    this.#panel.classList.remove('is-open')
    this.#backdrop?.classList.remove('is-open')
    this.#toggle?.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('search-filters-open')
    window.setTimeout(() => {
      if (!this.#panel.classList.contains('is-open')) {
        this.#panel.hidden = true
        if (this.#backdrop) this.#backdrop.hidden = true
      }
    }, 300)
    this.#lastFocused?.focus()
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#panel.classList.contains('is-open')) this.close()
  }
}

class PriceRangeSlider extends HTMLElement {
  #minThumb
  #maxThumb
  #minInput
  #maxInput
  #progress
  #min
  #max

  constructor() {
    super()
    this.#minThumb = this.querySelector('[data-price-thumb-min]')
    this.#maxThumb = this.querySelector('[data-price-thumb-max]')
    this.#minInput = this.querySelector('[data-price-input-min]')
    this.#maxInput = this.querySelector('[data-price-input-max]')
    this.#progress = this.querySelector('[data-price-progress]')
    if (!this.#minThumb || !this.#maxThumb) return

    this.#min = Number(this.#minThumb.min)
    this.#max = Number(this.#minThumb.max)

    this.#minThumb.addEventListener('input', () => this.#onThumbInput('min'))
    this.#maxThumb.addEventListener('input', () => this.#onThumbInput('max'))
    this.#minThumb.addEventListener('pointerdown', () => this.#raise('min'))
    this.#maxThumb.addEventListener('pointerdown', () => this.#raise('max'))
    this.#minInput?.addEventListener('change', () => this.#onTextInput('min'))
    this.#maxInput?.addEventListener('change', () => this.#onTextInput('max'))

    this.#updateProgress()
  }

  #raise(which) {
    this.#minThumb.style.zIndex = which === 'min' ? '5' : '1'
    this.#maxThumb.style.zIndex = which === 'max' ? '5' : '1'
  }

  #onThumbInput(which) {
    let minVal = Number(this.#minThumb.value)
    let maxVal = Number(this.#maxThumb.value)
    if (minVal > maxVal) {
      if (which === 'min') {
        minVal = maxVal
        this.#minThumb.value = String(minVal)
      } else {
        maxVal = minVal
        this.#maxThumb.value = String(maxVal)
      }
    }
    if (this.#minInput) this.#minInput.value = minVal.toFixed(2)
    if (this.#maxInput) this.#maxInput.value = maxVal.toFixed(2)
    this.#updateProgress()
  }

  #onTextInput(which) {
    const raw = which === 'min' ? this.#minInput.value : this.#maxInput.value
    let value = Number.parseFloat(String(raw).replace(',', '.'))
    if (Number.isNaN(value)) value = which === 'min' ? this.#min : this.#max
    value = Math.min(Math.max(value, this.#min), this.#max)

    if (which === 'min') {
      value = Math.min(value, Number(this.#maxThumb.value))
      this.#minThumb.value = String(value)
      this.#minInput.value = value.toFixed(2)
    } else {
      value = Math.max(value, Number(this.#minThumb.value))
      this.#maxThumb.value = String(value)
      this.#maxInput.value = value.toFixed(2)
    }
    this.#updateProgress()
  }

  #updateProgress() {
    if (!this.#progress) return
    const min = Number(this.#minThumb.value)
    const max = Number(this.#maxThumb.value)
    const range = this.#max - this.#min || 1
    const left = ((min - this.#min) / range) * 100
    const right = 100 - ((max - this.#min) / range) * 100
    this.#progress.style.left = `${left}%`
    this.#progress.style.right = `${right}%`
  }
}

class SearchResults extends HTMLElement {
  #sectionId
  #searchTerms
  #grid
  #count
  #filtersPanel

  constructor() {
    super()
    this.#sectionId = this.dataset.sectionId
    this.#searchTerms = this.dataset.searchTerms
    this.#grid = this.querySelector('[data-grid-container]')
    this.#count = this.querySelector('[data-product-count]')
    this.#filtersPanel = this.querySelector('[data-filters-panel]')

    this.addEventListener('change', (event) => this.#onChange(event))
    this.addEventListener('click', (event) => this.#onClick(event))
    window.addEventListener('popstate', () => this.#fetchAndRender(window.location.href, false))
  }

  #onChange(event) {
    const target = event.target
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return

    if (
      target.matches('select[name="sort_by"]') ||
      target.matches('input[type="checkbox"]') ||
      target.matches('input[type="range"]') ||
      target.matches('[data-price-input-min], [data-price-input-max]')
    ) {
      this.#submitForm()
    }
  }

  #getFacetsForm() {
    return document.getElementById(`FacetFiltersForm-${this.#sectionId}`)
  }

  #onClick(event) {
    const priceRemove = event.target.closest('[data-price-pill] .active-filters__remove')
    if (priceRemove) {
      const pill = priceRemove.closest('[data-price-pill]')
      const form = this.#getFacetsForm()
      const minInput = form?.querySelector(`[name="${pill.dataset.minName}"]`)
      const maxInput = form?.querySelector(`[name="${pill.dataset.maxName}"]`)
      if (minInput) minInput.value = ''
      if (maxInput) maxInput.value = ''
      this.#submitForm()
      return
    }

    const link = event.target.closest(
      '.active-filters__pill[href], .active-filters__clear-all[href], .pagination__link[href]'
    )
    if (link) {
      event.preventDefault()
      this.#fetchAndRender(link.href)
    }
  }

  #submitForm() {
    const form = this.#getFacetsForm()
    if (!form) return
    const params = new URLSearchParams(new FormData(form))
    params.set('q', this.#searchTerms)
    params.set('type', 'product')

    const minThumb = this.querySelector('[data-price-thumb-min]')
    const maxThumb = this.querySelector('[data-price-thumb-max]')
    const minInput = this.querySelector('[data-price-input-min]')
    const maxInput = this.querySelector('[data-price-input-max]')
    if (minThumb && maxThumb && minInput && maxInput) {
      const atDefaultRange =
        Number(minInput.value || 0) <= Number(minThumb.min) &&
        Number(maxInput.value || maxThumb.max) >= Number(maxThumb.max)
      if (atDefaultRange) {
        params.delete(minInput.name)
        params.delete(maxInput.name)
      }
    }

    for (const [key, value] of [...params]) {
      if (value === '') params.delete(key)
    }
    const url = `${window.location.pathname}?${params.toString()}`
    this.#fetchAndRender(url)
  }

  async #fetchAndRender(url, pushHistory = true) {
    this.#grid?.classList.add('is-loading')
    const separator = url.includes('?') ? '&' : '?'

    // The panel swap below replaces every <details> wholesale, so any group
    // the shopper had manually expanded (that isn't also "active", which is
    // the only thing the freshly-rendered HTML knows to open) would otherwise
    // silently collapse on every filter change.
    const openParams = new Set(
      Array.from(this.querySelectorAll('[data-filters-panel] details[open]')).map((details) => details.dataset.filterParam)
    )

    try {
      const response = await fetch(`${url}${separator}section_id=${this.#sectionId}`)
      const text = await response.text()
      const doc = new DOMParser().parseFromString(text, 'text/html')

      const newGrid = doc.querySelector('[data-grid-container]')
      if (newGrid && this.#grid) {
        this.#grid.innerHTML = newGrid.innerHTML
        // Product cards now render Loox's .loox-rating markup instead of
        // Air Reviews, which doesn't expose a documented global to re-scan
        // freshly swapped-in DOM - see the matching comment in
        // main-collection-product-grid.liquid.
      }

      const newCount = doc.querySelector('[data-product-count]')
      if (newCount && this.#count) this.#count.innerHTML = newCount.innerHTML

      const newFiltersPanel = doc.querySelector('[data-filters-panel]')
      if (newFiltersPanel && this.#filtersPanel) {
        this.#filtersPanel.innerHTML = newFiltersPanel.innerHTML
        for (const details of this.#filtersPanel.querySelectorAll('details[data-filter-param]')) {
          if (openParams.has(details.dataset.filterParam)) details.open = true
        }
      }

      if (pushHistory) history.pushState({}, '', url)
    } finally {
      this.#grid?.classList.remove('is-loading')
    }
  }
}

if (!customElements.get('search-filters')) customElements.define('search-filters', SearchFilters)
if (!customElements.get('price-range-slider')) customElements.define('price-range-slider', PriceRangeSlider)
if (!customElements.get('search-results')) customElements.define('search-results', SearchResults)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
class ProductFaq extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-faq-trigger]');
    if (!trigger) return;

    const item = trigger.closest('[data-faq-item]');
    if (!item) return;
    
    const willOpen = !item.hasAttribute('data-faq-open');

    for (const other of this.querySelectorAll('[data-faq-item]')) {
      if (other === item) continue;
      other.removeAttribute('data-faq-open');
      other.querySelector('[data-faq-trigger]')?.setAttribute('aria-expanded', 'false');
    }

    item.toggleAttribute('data-faq-open', willOpen);
    trigger.setAttribute('aria-expanded', String(willOpen));
  }
}

if (!customElements.get('product-faq')) {
  customElements.define('product-faq', ProductFaq);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
class ProductIngredients extends HTMLElement {
  constructor() {
    super();
    this.orbName = this.querySelector('[data-orb-name]');
    this.orbFormula = this.querySelector('[data-orb-formula]');
    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-ingredient-trigger]');
    if (!trigger) return;

    const index = trigger.dataset.index;

    for (const btn of this.querySelectorAll('[data-ingredient-trigger]')) {
      const active = btn.dataset.index === index;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    }

    for (const panel of this.querySelectorAll('[data-ingredient-panel]')) {
      panel.hidden = panel.dataset.index !== index;
    }

    if (this.orbName) this.orbName.textContent = trigger.dataset.short;
    if (this.orbFormula) this.orbFormula.textContent = trigger.dataset.formula;
  }
}

if (!customElements.get('product-ingredients')) {
  customElements.define('product-ingredients', ProductIngredients);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  #observer
  #request

  connectedCallback() {
    this.#observer?.disconnect()
    this.#observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)
        this.#load()
      },
      { rootMargin: '0px 0px 400px 0px' }
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
    this.#request?.abort()
  }

  async #load() {
    try {
      this.#request?.abort()
      this.#request = new AbortController()
      const response = await fetch(`${this.dataset.url}&product_id=${this.dataset.productId}`, {
        signal: this.#request.signal,
      })
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`)
      const text = await response.text()
      if (!this.isConnected) return
      const doc = new DOMParser().parseFromString(text, 'text/html')
      const newContent = doc.querySelector('product-recs')
      if (newContent && newContent.innerHTML.trim().length) {
        this.innerHTML = newContent.innerHTML
        // Product cards now render Loox's .loox-rating markup instead of
        // Air Reviews, which doesn't expose a documented global to re-scan
        // freshly injected DOM the way avadaAirReviewRerender did - stars
        // on lazy-loaded recommendations may stay empty until Loox ships
        // one (see the same note in main-collection-product-grid.liquid).
      }
    } catch (error) {
      if (error.name === 'AbortError') return
      console.error('Related products error:', error)
    }
  }
}

if (!customElements.get('product-recs')) {
  customElements.define('product-recs', ProductRecommendations)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-reels"] && !Shopify.designMode) return;
  try {
    
class YoutubeReelPlayer extends HTMLElement {
  #backdrop
  #modal
  #closeButton
  #frame
  #lastFocused

  constructor() {
    super()
    this.#backdrop = this.querySelector('[data-video-modal-backdrop]')
    this.#modal = this.querySelector('.youtube-reels__modal')
    this.#closeButton = this.querySelector('[data-video-modal-close]')
    this.#frame = this.querySelector('[data-video-modal-frame]')
    if (!this.#backdrop || !this.#modal || !this.#frame) return

    this.addEventListener('click', (event) => this.#onClick(event))
    document.addEventListener('keydown', (event) => this.#onKeydown(event))
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-video-id]')
    if (trigger) {
      this.#open(trigger.dataset.videoId, trigger)
      return
    }
    if (event.target.closest('[data-video-modal-close]') || event.target === this.#backdrop) {
      this.#close()
    }
  }

  #onKeydown(event) {
    if (event.key === 'Escape' && this.#modal.classList.contains('is-open')) this.#close()
  }

  #open(videoId, trigger) {
    this.#lastFocused = trigger
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture'
    iframe.allowFullscreen = true
    iframe.title = 'YouTube video player'
    this.#frame.innerHTML = ''
    this.#frame.appendChild(iframe)

    this.#backdrop.hidden = false
    this.#modal.hidden = false
    requestAnimationFrame(() => {
      this.#backdrop.classList.add('is-open')
      this.#modal.classList.add('is-open')
    })
    document.body.classList.add('video-modal-open')
    this.#closeButton.focus()
  }

  #close() {
    this.#backdrop.classList.remove('is-open')
    this.#modal.classList.remove('is-open')
    document.body.classList.remove('video-modal-open')
    window.setTimeout(() => {
      this.#backdrop.hidden = true
      this.#modal.hidden = true
      this.#frame.innerHTML = ''
    }, 250)
    this.#lastFocused?.focus()
  }
}

if (!customElements.get('youtube-reel-player')) {
  customElements.define('youtube-reel-player', YoutubeReelPlayer)
}

  } catch(e) { console.error(e); }
})();
})();
